import config from "../../../../config";
import { getlist, post } from "../../../../contexts/apicontexts";

const normalizeId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const normalizeString = (value) => String(value ?? "").trim();
const normalizeJoinedValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((entry) => normalizeString(entry)).filter(Boolean).join(", ");
  }

  return normalizeString(value);
};

const pickFirstText = (...values) => {
  for (const value of values) {
    const text = normalizeJoinedValue(value);
    if (text) return text;
  }

  return "";
};

const normalizeTicketName = (item) => {
  const ticketDetails = item?.ticket ?? item?.Ticket ?? null;
  const ticketList = item?.tickets ?? item?.Tickets ?? null;

  const ticketListText = Array.isArray(ticketList)
    ? ticketList
        .map((ticket) =>
          pickFirstText(
            ticket?.ticketName,
            ticket?.TicketName,
            ticket?.ticketSubject,
            ticket?.TicketSubject,
            ticket?.subject,
            ticket?.Subject,
            ticket?.title,
            ticket?.Title,
            ticket?.name,
            ticket?.Name
          )
        )
        .filter(Boolean)
        .join(", ")
    : "";

  return pickFirstText(
    item?.ticketName,
    item?.TicketName,
    item?.ticketNames,
    item?.TicketNames,
    item?.ticketSubject,
    item?.TicketSubject,
    item?.ticketSubjects,
    item?.TicketSubjects,
    item?.subject,
    item?.Subject,
    item?.subjects,
    item?.Subjects,
    item?.ticketTitle,
    item?.TicketTitle,
    item?.ticketTitles,
    item?.TicketTitles,
    item?.title,
    item?.Title,
    ticketDetails?.ticketName,
    ticketDetails?.TicketName,
    ticketDetails?.ticketSubject,
    ticketDetails?.TicketSubject,
    ticketDetails?.subject,
    ticketDetails?.Subject,
    ticketDetails?.title,
    ticketDetails?.Title,
    ticketDetails?.name,
    ticketDetails?.Name,
    ticketListText,
    item?.name,
    item?.Name
  );
};

export const normalizeTicketSummaryReportItem = (item) => ({
  ticketId: Number(item?.ticketId ?? item?.TicketId ?? 0),
  organizationId: Number(item?.organizationId ?? item?.OrganizationId ?? 0),
  organizationName: normalizeString(item?.organizationName ?? item?.OrganizationName) || "Unknown Organization",
  customerId: Number(item?.customerId ?? item?.CustomerId ?? 0),
  customerName: normalizeString(item?.customerName ?? item?.CustomerName) || "Unknown Customer",
  customerCode: normalizeString(item?.customerCode ?? item?.CustomerCode),
  customerUserId: normalizeString(item?.customerUserId ?? item?.CustomerUserId),
  customerUserName: normalizeString(item?.customerUserName ?? item?.CustomerUserName) || "Unknown User",
  customerUserEmail: normalizeString(item?.customerUserEmail ?? item?.CustomerUserEmail),
  employeeUserId: normalizeString(item?.employeeUserId ?? item?.EmployeeUserId),
  employeeName: normalizeString(item?.employeeName ?? item?.EmployeeName) || "Unassigned",
  employeeEmail: normalizeString(item?.employeeEmail ?? item?.EmployeeEmail),
  ticketName: normalizeTicketName(item),
  openDate: normalizeString(item?.openDate ?? item?.OpenDate),
  status: normalizeString(item?.status ?? item?.Status) || "Unknown",
  ticketCount: Number(item?.ticketCount ?? item?.TicketCount ?? 0),
  taskCount: Number(item?.taskCount ?? item?.TaskCount ?? item?.ticketCount ?? item?.TicketCount ?? 0),
});

export const normalizeTicketSummaryReportResponse = (response) => ({
  items: Array.isArray(response?.items ?? response?.Items)
    ? (response?.items ?? response?.Items).map(normalizeTicketSummaryReportItem)
    : [],
  totalTickets: Number(response?.totalTickets ?? response?.TotalTickets ?? 0),
  totalOrganizations: Number(response?.totalOrganizations ?? response?.TotalOrganizations ?? 0),
  totalCustomers: Number(response?.totalCustomers ?? response?.TotalCustomers ?? 0),
});

export const fetchOrganizationCustomerTicketSummary = async (filters) => {
  const payload = {
    organizationId: normalizeId(filters?.organizationId),
    customerId: normalizeId(filters?.customerId),
    customerUserId: normalizeString(filters?.customerUserId) || null,
    employeeUserId: normalizeString(filters?.employeeUserId) || null,
    startDate: filters?.startDate || null,
    endDate: filters?.endDate || null,
    status: normalizeString(filters?.status) || null,
  };

  const response = await post(`${config.baseurl}TicketReport/organization-customer-summary`, payload);
  if (response?.status === 200) {
    return normalizeTicketSummaryReportResponse(response.data || {});
  }

  throw new Error(response?.message || "Ticket summary report could not be loaded.");
};

export const fetchTicketReportStatusOptions = async () => {
  const response = await getlist(`${config.baseurl}TicketReport/status-options`);
  if (response?.status === 200 && Array.isArray(response.data)) {
    return response.data.map((item) => normalizeString(item)).filter(Boolean);
  }

  throw new Error("Ticket status options could not be loaded.");
};
